var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPethair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#06addf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ad3a6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M160,139.21h42.719v46.831H160Z",
    transform: "translate(-160 -139.21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M311,459h9.2v15.208H311Z",
    transform: "translate(-311 -459)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-846.29 -2642.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431",
    transform: "translate(560 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(286.29 2636.485)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446",
    transform: "translate(4.1 4.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download_3_",
    "data-name": "download (3)",
    transform: "translate(760.221 2505.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M342.07,343.1l1.037-1.037,4.962,4.962-1.037,1.037Z",
    transform: "translate(-164.51 -164.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M181.868,353.206l-9.708,9.708a3.892,3.892,0,1,1-5.5-5.5l9.708-9.708-.113-.113a4.056,4.056,0,0,0-2.887-1.2,4.11,4.11,0,0,0-.928.11l1.39,1.39-.925.925-1.764-1.763a4.1,4.1,0,0,0-.661.534l-.44.44,1.827,1.827-.925.925-1.827-1.827-1.038,1.038,1.827,1.827-.925.925-1.827-1.827-1.038,1.038,1.827,1.827-.925.925-1.827-1.827-1.038,1.038,1.827,1.827-.925.925-1.773-1.773a8.032,8.032,0,0,0-.953,1.581l2.236.926-.5,1.209-2.18-.9a8.244,8.244,0,0,0-.272,1.769h2.6v1.308H161.65a8.046,8.046,0,0,0,.391,1.7l2.022-.838.5,1.209-2,.83a8.1,8.1,0,0,0,.976,1.421l1.518-1.518.925.925-1.518,1.517a8.159,8.159,0,0,0,1.421.976l.83-2,1.209.5-.837,2.022a8.045,8.045,0,0,0,1.7.391v-2.557H170.1v2.6a8.143,8.143,0,0,0,1.769-.273l-.9-2.18,1.209-.5.926,2.236a8.08,8.08,0,0,0,1.581-.953l-1.773-1.773.925-.925,1.827,1.827,1.037-1.037-1.827-1.827.925-.925,1.827,1.827,1.037-1.037-1.827-1.827.925-.925,1.827,1.827,1.037-1.037-1.827-1.827.925-.925,1.827,1.827.44-.44a4.131,4.131,0,0,0,.535-.661l-1.764-1.763.925-.925,1.39,1.39a4.128,4.128,0,0,0,.109-.927,4.055,4.055,0,0,0-1.2-2.887Z",
    transform: "translate(0 -168.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M231.067,371.66l-9.709,9.709a2.584,2.584,0,1,0,3.654,3.654l9.708-9.709-1.364-1.365-7.714,7.714-.925-.925,7.714-7.713Zm-8.04,12.619-.925-.925,1.308-1.308.925.925Z",
    transform: "translate(-53.778 -191.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M547.5,191.662a.654.654,0,1,1-.654-.654.654.654,0,0,1,.654.654",
    transform: "translate(-350.59 -26.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M398.087,161.41a3.026,3.026,0,0,0-2.154.892l-2.57,2.57a2.487,2.487,0,0,0-.733,1.771,3.785,3.785,0,0,1-1.117,2.7l-8.751,8.75,1.692,1.692,8.751-8.751a3.837,3.837,0,0,1,2.7-1.117,2.523,2.523,0,0,0,1.771-.733l2.57-2.57a3.046,3.046,0,0,0-2.154-5.2Zm-.224,5.233a1.962,1.962,0,1,1,1.962-1.962A1.965,1.965,0,0,1,397.863,166.643Z",
    transform: "translate(-201.606)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "download_2_",
    "data-name": "download (2)",
    d: "M280.872,246.043a11.077,11.077,0,0,0-2.274-9.963,10.885,10.885,0,0,0-9.445-3.853l-29.919,2.778-8.735-33.5a18.758,18.758,0,0,0-11.091-12.669l.911-7.892a11.958,11.958,0,0,0-11.868-13.321l-5.4.176a5.168,5.168,0,0,0-4.84,6.41l3.675,14.8c-.014.016-.032.026-.046.042a6.06,6.06,0,0,0-1.523,4.676l4.764,46.045v16.139a11.28,11.28,0,0,0,3.228,7.892h-2.163a1.718,1.718,0,1,0,0,3.435h71.515a1.718,1.718,0,0,0,0-3.436H275.88a7.15,7.15,0,0,0,.835-1.914ZM201.846,171.92a1.732,1.732,0,0,1,1.324-.689l5.28-.173a8.524,8.524,0,0,1,8.455,9.493l-.749,6.493H204.94l-3.393-13.661a1.719,1.719,0,0,1,.3-1.462Zm2.549,19.429a2.7,2.7,0,0,1,2.09-.864h.022l6.719.41a15.347,15.347,0,0,1,13.948,11.476l8.593,32.953-27.426,2.545-4.6-44.5a2.574,2.574,0,0,1,.657-2.023Zm56.992,72.45H216.409a7.9,7.9,0,0,1-7.892-7.892V241.3l1.507-.141,59.441-5.514a7.456,7.456,0,0,1,6.515,2.653,7.549,7.549,0,0,1,1.57,6.873L273.4,261.011a3.734,3.734,0,0,1-3.6,2.788h-8.409Z",
    transform: "translate(696.483 2515.881)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download_15_",
    "data-name": "download (15)",
    transform: "translate(773.471 2564.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(160 139.21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M202.8,169.384a1,1,0,0,0-1.987.187c.285,5.316-3.7,6.77-5.593,7.161-.987-7.5-9.818-17.807-11.359-18.579-.465-.291-1.026-2.569-1.152-4.688,0-.024-.015-.044-.018-.068a5.084,5.084,0,0,0,.582-.769c2.337-3.841-1.077-11.319-3.721-12.972s-8.967,1.693-10.211,2.379a1.011,1.011,0,0,0-.387.382l-2.17,3.83-5.613.914a1,1,0,0,0-.838.95c-.019.543-.123,5.368,2.168,7.523a3.747,3.747,0,0,0,3.031,1.007c3.264-.311,4.806.375,5.226.7-.032.123-.075.28-.126.465-.871,3.214-3.481,12.839,2.3,17.312v6.428c-1.249.576-3.359,1.792-3.4,3.467a1,1,0,0,0,.975,1.021h.023a1,1,0,0,0,1-.976c.009-.379,1.286-1.34,2.764-1.923a1,1,0,0,0,.633-.929v-7.6a1,1,0,0,0-.436-.825c-5.166-3.517-2.731-12.5-1.93-15.456a4.89,4.89,0,0,0,.244-1.127,1.73,1.73,0,0,0-.647-1.29c-1.2-1.087-3.745-1.559-6.817-1.26a1.758,1.758,0,0,1-1.469-.472c-1.148-1.078-1.48-3.639-1.537-5.186l5.244-.854a1,1,0,0,0,.708-.493l2.265-4c3.052-1.642,6.882-2.964,7.943-2.3,1.854,1.158,4.7,7.562,3.074,10.24-1.148,1.885-3.443,1.521-4.532,1.213l-.127-6.093a1,1,0,1,0-2,.042l.141,6.794a1,1,0,0,0,.613.9,7.467,7.467,0,0,0,5.142.229c.2,1.851.733,4.55,2.147,5.258,1.134.652,10.212,11.22,10.356,17.957a1,1,0,0,0,1.052.976,9.67,9.67,0,0,0,6.351-2.9,8.793,8.793,0,0,1-1.845,4.421,4.491,4.491,0,0,1-3.678,1.433,1,1,0,1,0-.066,1.995c.1,0,.2.006.3.006a6.361,6.361,0,0,0,4.931-2.1c3.544-3.918,2.5-12,2.45-12.341Z",
    transform: "translate(-160.3 -139.206)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452",
    transform: "translate(174.932 170.833)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M319.892,471.336c-1.926-.588-3.108-1.535-3.512-2.816-.925-2.933,2.135-6.9,2.167-6.937a1,1,0,0,0-1.571-1.231c-.153.195-3.739,4.827-2.5,8.764a5.254,5.254,0,0,0,1.16,2,5.7,5.7,0,0,0-3.478,1.145,2.24,2.24,0,0,0-.677,1.934,1,1,0,0,0,.99.883.929.929,0,0,0,.117-.007,1,1,0,0,0,.876-1.108.268.268,0,0,1,.085-.271c.775-.756,3.983-.695,5.91-.417a1,1,0,0,0,.435-1.943Z",
    transform: "translate(-311.416 -459.875)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPethair);
export default __webpack_public_path__ + "static/media/pethair.7eb1d3d884c756f03d5284d37dc7df97.svg";
export { ForwardRef as ReactComponent };